import React, { useEffect, useState } from "react";
import api from "../../api/axiosInstance";
import { useParams } from "react-router-dom";

import NavigationTabBar from "../../components/navigation/NavigationTabBar";
import FooterSection from "../../components/navigation/FooterSection";
import { useAuth } from "../../components/navigation/AuthenticationStateManager";

const BootcampRegister = () => {

  const { isAuthenticated } = useAuth();
  const { bootcampId } = useParams();

  const [bootcamp, setBootcamp] = useState(null);

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: ""
  });

  const [timeLeft, setTimeLeft] = useState("");

  /* FETCH BOOTCAMP */

  useEffect(() => {

    const loadBootcamp = async () => {

      try {

        const res = await api.get("/api/bootcamp/bootcamps");

        const selected = res.data.find(
          (b) => b._id === bootcampId
        );

        setBootcamp(selected);

      } catch (err) {

        console.error("Bootcamp load error");

      }

    };

    loadBootcamp();

  }, [bootcampId]);



  /* COUNTDOWN TIMER */

  useEffect(() => {

    if (!bootcamp) return;

    const interval = setInterval(() => {

      const diff =
        new Date(bootcamp.date).getTime() -
        new Date().getTime();

      if (diff <= 0) {

        setTimeLeft("Bootcamp started");

        return;

      }

      const days = Math.floor(
        diff / (1000 * 60 * 60 * 24)
      );

      const hours = Math.floor(
        (diff % (1000 * 60 * 60 * 24)) /
        (1000 * 60 * 60)
      );

      const minutes = Math.floor(
        (diff % (1000 * 60 * 60)) /
        (1000 * 60)
      );

      setTimeLeft(`${days}d ${hours}h ${minutes}m`);

    }, 1000);

    return () => clearInterval(interval);

  }, [bootcamp]);


  /* SUBMIT FORM */

  const handleSubmit = async (e) => {

    e.preventDefault();

    try {

      await api.post("/api/bootcamp/register", {
        ...form,
        bootcampId
      });

      alert("Registration successful!");

      setForm({
        name: "",
        email: "",
        phone: ""
      });

    } catch (err) {

      alert("Registration failed");

    }

  };


  if (!bootcamp) return null;



  return (

    <div className="min-h-screen bg-background">

      <NavigationTabBar
        isAuthenticated={isAuthenticated}
      />

      <main className="pt-20 pb-20">

        <div className="max-w-6xl mx-auto px-6">


          {/* HERO SECTION */}

          <div className="text-center mb-16">

            <h1 className="text-5xl font-bold mb-4">
             Register for the Upcoming Bootcamp Session
            </h1>

            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Join our instructor-led bootcamp and master
              {" "}
              {bootcamp.category}
              {" "}
              with real interview-ready projects.
            </p>

          </div>


          {/* MAIN GRID */}

          <div className="grid md:grid-cols-2 gap-10">


            {/* LEFT CARD */}

            <div className="bg-card border rounded-xl p-8">

              <h2 className="text-2xl font-bold mb-4">
                Bootcamp Details
              </h2>

              <p className="text-muted-foreground mb-2">
                Trainer: {bootcamp.trainer}
              </p>

              <p className="text-muted-foreground mb-2">
                Date: {new Date(bootcamp.date).toLocaleDateString()}
              </p>

              <p className="text-muted-foreground mb-4">
                Price: ₹{bootcamp.price}
              </p>


              {/* SEATS LEFT */}

              <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-5">

                <p className="text-red-600 font-semibold text-lg">
                  🔥 Only {bootcamp.seatsLeft} seats left
                </p>

              </div>


              {/* COUNTDOWN */}

              <div className="bg-primary/10 border border-primary/20 rounded-lg p-6 text-center">

                <p className="text-muted-foreground text-sm mb-2">
                  Bootcamp starts in
                </p>

                <p className="text-3xl font-bold text-primary">
                  {timeLeft}
                </p>

              </div>

            </div>



            {/* RIGHT FORM */}

            <div className="bg-card border rounded-xl p-8">

              <div className="mb-4 text-sm text-muted-foreground">
                ✔ Instant confirmation <br />
                ✔ Calendar invite included <br />
                ✔ Limited seats bootcamp
              </div>

              <form
                onSubmit={handleSubmit}
                className="space-y-4"
              >

                <input
                  type="text"
                  placeholder="Full Name"
                  required
                  value={form.name}
                  className="w-full border rounded-lg p-3"
                  onChange={(e) =>
                    setForm({
                      ...form,
                      name: e.target.value
                    })
                  }
                />

                <input
                  type="email"
                  placeholder="Email Address"
                  required
                  value={form.email}
                  className="w-full border rounded-lg p-3"
                  onChange={(e) =>
                    setForm({
                      ...form,
                      email: e.target.value
                    })
                  }
                />

                <input
                  type="tel"
                  placeholder="Phone Number"
                  required
                  value={form.phone}
                  className="w-full border rounded-lg p-3"
                  onChange={(e) =>
                    setForm({
                      ...form,
                      phone: e.target.value
                    })
                  }
                />

                <button
                  type="submit"
                  className="w-full bg-primary text-white py-3 rounded-lg text-lg"
                >
                  Secure Your Seat
                </button>

              </form>

            </div>

          </div>



          {/* WHY JOIN */}

          <div className="mt-20">

            <h2 className="text-3xl font-bold text-center mb-10">
              Why Join This Bootcamp
            </h2>

            <div className="grid md:grid-cols-3 gap-8">

              <div className="border rounded-xl p-6 text-center">
                <h3 className="font-semibold mb-2">
                  Live Mentorship
                </h3>
                <p className="text-muted-foreground">
                  Learn directly from industry experts.
                </p>
              </div>

              <div className="border rounded-xl p-6 text-center">
                <h3 className="font-semibold mb-2">
                  Interview Focused
                </h3>
                <p className="text-muted-foreground">
                  Designed for real job interviews.
                </p>
              </div>

              <div className="border rounded-xl p-6 text-center">
                <h3 className="font-semibold mb-2">
                  Hands-on Learning
                </h3>
                <p className="text-muted-foreground">
                  Practice with real coding problems.
                </p>
              </div>

            </div>

          </div>

        </div>

      </main>

      <FooterSection />

    </div>

  );

};

export default BootcampRegister;